import {Text} from '@eitje/web_components'

export const HeaderRow = ({item}) => <Text bold t={`common.${item.description}`} infoIconMessage={item.infoIconMessage} />
